module.exports = __webpack_public_path__ + "img/sgw.f0386ceb.jpg";